const colors = {
  white: '#fff',
  black: '#000',
  lightGrey: '#F3F3F5',
  genericLighter: '#F0F5FF',
  grey: 'grey',
  midGrey: '#333333',
  mediumGrey: '#D3D3D3',
  darkGrey: '#999999',
  darkGreen: '#00643B',
  paleGreen: '#def299',
  oilGrey: '#686F6B',
  greenLight: '#BED62F',
  flatOrange: '#FF8E0D',
  ultraLightGreen: '#B9D137',
  ultraLighterGreen: '#EEFADC',
  gradientsGreenLight: '#BFD72F',
  gradientsGreenDark: '#8CC73F',
  gradientsOrangeDark: '#F76B1C',
  gradientsOrangeLight: '#FAD961',
  gradientsLavender: '#40CB8A',
  gradientsBlueGreen: '#8B65DF',
  bgSecondary: '#F2F2F2',
  greyText: '#707070',
  greyBackground: '#f5f5f5',
  transparent: 'transparent',
  primaryTextColor: '#191D3A',
  disabledPrimaryTextColor: '#757789',
  disabledPrimaryTextColorLight: '#E8E8EB',
  layerGreyBg: 'rgba(0, 0, 0, 0.5)',
  greyTextColor: '#707070',
  boxShadowGrey: 'rgba(200, 200, 200, 0.7)',
  paymentMethodCardBorder: '#78CA0C',
  paymentMethodCardBorderGrey: '#DADADA',
  firstCardShadow: 'rgba(0, 0, 0, 0.15)',
  withdrawCardShadow: 'rgba(0, 0, 0, 0.08)',
  collapsibleDetailsLabel: '#44475f',
  collapsibleDetailsContent: '#444660',
  yellowInput: '#FFCC33',
  redInput: '#FF1A1A',
  notWinning: '#FF1A1A',
  isWinning: '#40CD8C',
  inherit: 'inherit',
  yellowNote: '#FABB00',
  orangeNote: '#FFAF1E',
  yellowNoteLight: '#F5E11C',
  linkTextColor: '#0B6B44',
  loaderBg: 'rgba(255, 255, 255, 0.95)',
  checkboxBorder: '#DFDFDF',
  checkboxShadow: 'rgba(0, 0, 0, 0.2)',
  cardShadow: 'rgba(204,204,204,0.3)',
  activeCardBg: '#F4F4F4',
  cardSeparator: '#E6E6E6',
  cardSeparatorLight: '#f4f4f4',
  consumedAmountText: '#56596e',
  consumedAmountTextShadow: 'rgba(51,51,51,0.24)',
  inputTextBorder: '#CCCCCC',
  disabledInputTextBackground: '#FAFAFA',
  disabledInputTextValue: '#b1b2bc',
  horizontalRulerColor: '#E6E6E6',
  greenCheck: '#409142',
  greyUltralight: '#FAFAFA',
  redUltralight: '#FFF5F5',
  brightRed: '#ff989d',
  greyUltradark: '#1B224C',
  navBarLinkSelected: '#F4F9EC',
  navBarLogoutSeparator: '#D9D9D9',
  gradientsOvalOrangeDark: '#f16a22',
  gradientsOvalOrangeLight: '#fa9619',
  gradientsOvalOrangeLightSecondary: '#FF7200',
  lightPrimaryTextColor: '#747788',
  colorAmount: '#5cbd58',
  textColorTable: '#515357',
  pageNumberColor: '#202440',
  pageNumberSelectedBg: '#92C93D',
  gradientsStatusYellowLight: '#FFF96C',
  gradientsStatusYellowDark: '#FFF505',
  gradientsStatusBlueLight: '#084AA3',
  gradientsStatusBlueDark: '#0B63DB',
  gradientsStatusGreyLight: '#9D9C9C',
  gradientsStatusGreyDark: '#9D9C9C',
  gradientsStatusGreenLight: '#BFD72F',
  gradientsStatusGreenDark: '#8CC73F',
  gradientsStatusRedLight: '#EA2B1F',
  gradientsStatusRedDark: '#EE4E44',
  heavenly: '#7ED0E6',
  lightOrange: '#F4BF1A',
  lightGreen: '#95BD0D',
  gameBonusValidityLabel: '#67aaf9',
  gameBonusBannerWinningBackground: '#dff5eb',
  gameBonusBannerArchiveBackground: '#2F3C43',
  lightBlue: '#73aeff',
  promoCodeCardShadow: 'rgba(0,0,0,0.1)',
  promoCodeCardGradientPink: '#D23078',
  promoCodeCardGradientOrange: '#FE6161',
  promoCodeCardGradientLightOrange: '#FF7955',
  promoCodeButtonBackground: '#95CA3C',
  promoCodeButtonShadow: '#77A935',
  promoCodeButtonShadowDisabled: '#acafc2',
  promoCodeInputTextBackground: 'rgba(255, 255, 255, 0.25)',
  bonusExpirationDate: '#858689',
  bonusBlackColumn: '#25282D',
  inviteFriendsDocumentButtonLabel: '#00643A',
  cream: '#FAF0D4',
  cremeBrulee: '#ff8200',
  salmonRed: '#fcdede',
  inputColor: '#3a3a3a',
  inputBorderColor: '#D1D2D8',
  inputLabelIdleColor: '#8f8f8f',
  pageTitle: '#212121',
  darkTitle: '#46495f',
  greenUltraDark: '#2F3C43',
  blackTwelve: '#222222',
  intenseGreen: '#0B7D3E',
  intenseGreenHighlight: '#0d994c',
  darkIntenseGreen: '#005E3B',
  darkOverlayBackground: 'rgba(50, 50, 50, 0.6)',
  darkBackground: '#303c42',
  greySuperlight: '#E0E0E0',
  higherPriorityBackground: '#F8FAE6',
  highlightedBackground: '#F7F8F9',
  boderTableTicket: '#EAEAEA',
  modalBoxShadow: 'rgba(25,29,58,0.1)',
  accordionGreenSelection: '#BDD600',
  messageBackground: '#e1eefe',
  messageBorder: '#67aaf9',
  messageBackgroundOrange: '#FEF1CC',
  messageBorderOrange: '#FABB00',
  warningBackground: '#fcdede',
  warningBorder: '#EB1E23',
  cardPayShadow: 'rgba(0, 0, 0, 0.1)',
  cardPayFocusShadow: 'rgba(0, 0, 0, 0.3)',
  barcodeLabel: '#1A234D',
  withdrawalCode: '#292D33',
  barcodeBackgroundLight: '#aac025',
  barcodeBackgroundDark: '#7bb234',
  promoCardBackground: '#d8d8d8',
  promoCardShadow: 'rgba(0,0,0,0.14)',
  progressBarBackgroundExpired: '#9FA0A4',
  progressBarBackgroundActive: '#40cd8c',
  progressBarBackgroundDefault: '#FFFFFF',
  progressBarColorText: '#222222',
  gamebonusPolicyTableRow: '#DDDDDD',
  gamebonusPolicyTableHeader: '#0B7D3E',
  rechargeFailedsubTitle: '#767789',
  verifiedState: '#0A7D41',
  notVerifiedState: '#FABB00',
  receivedDocumentState: '#67AAF9',
  rejectedDocumentState: '#EB1E23',
  errorWithdrawalStatus: '#EB1E23',
  neutralLightBlack: '#9B9B9B',
  neutralBlack: '#030303',
  neutralMediumGray: '#E5E8EC',
  neutralLightGray: '#f0f2f4',
  disabledCheckedBoxBg: '#959EAB',
  inactiveStatus: '#959eab',
  alertBarBackgroundRed: '#FBD2D3',
  alertBarBackgroundOrange: '#FFF7E8',
  alertBarBackgroundGreen: '#F2FAD7',
  alertBarBorderOrange: 'rgba(255, 142, 13, 0.5)',
  darkGreenFeedback: '#005F3B',
  modalCtaText: '#262C2F',
  alertBarBorderGreen: 'rgba(190, 214, 47, 0.5)',
  selectedGreenBackground: '#F2FAD7',
  promoRechargeBgStart: '#95c11f',
  promoRechargeBgEnd: '#007349',
  disabledButtonBorder: '#DEF199',
  disabledWhiteWithGreenButtonBackground: 'rgba(255, 255, 255, 0.5)',
  modifyPasswordRadioInput: '#D4D5D5',
  activeMessageColor: '#F0F2F4',
  slateBlue: '#36455E',
  lightPastelYellow: '#FFF2CC',
  goldenYellow: '#FFBF00',
  paleBlue: '#E7F2FA',
};

export const gradients = {
  lightGrey: `linear-gradient(
    90deg,
    ${colors.gradientsStatusGreyDark} 0%,
    ${colors.gradientsStatusGreyDark} 100%
  )`,
  disabledGrey: 'linear-gradient(90deg, #cccccc 0%, #acafc2 99.97%)',
  warningRed: `linear-gradient(
    90deg,
    ${colors.gradientsStatusRedLight} 0%,
    ${colors.gradientsStatusRedDark} 100%
  )`,
  orange: `linear-gradient(
    90deg,
    ${colors.gradientsOrangeLight} 0%,
    ${colors.gradientsOrangeDark} 100%
  )`,
  highlightOrange: `linear-gradient(45deg, #FF8E0D 0%, #FFAF1E 100%)`,
  greenToDarkGreen: `linear-gradient(
    90deg,
    ${colors.gradientsGreenLight} 0%,
    ${colors.gradientsGreenDark} 100%
  )`,
  electricLime: 'linear-gradient(45deg, #00D6BC 0%, #B9D732 100%)',
  yellow: `linear-gradient(
    90deg,
    ${colors.gradientsStatusYellowLight} 0%,
    ${colors.gradientsStatusYellowDark} 100%
  )`,
  blue: `linear-gradient(
    90deg,
    ${colors.gradientsStatusBlueLight} 0%,
    ${colors.gradientsStatusBlueDark} 100%
  )`,
  promoCodeCard: `linear-gradient(
    0deg,
    ${colors.promoCodeCardGradientPink} 0%,
    ${colors.promoCodeCardGradientOrange} 73%,
    ${colors.promoCodeCardGradientLightOrange} 100%
  )`,
  promoCodeCardDesktop: `linear-gradient(
    45deg,
    ${colors.promoCodeCardGradientPink} 0%,
    ${colors.promoCodeCardGradientOrange} 73%,
    ${colors.promoCodeCardGradientLightOrange} 100%
  )`,
  inviteFriendsOrange: `linear-gradient(
    90deg,
    ${colors.gradientsOvalOrangeLight} 0%,
    ${colors.gradientsOvalOrangeLightSecondary} 100%
  )`,
  barcodeBackground: `linear-gradient(
    90deg,
    ${colors.barcodeBackgroundLight} 0%,
    ${colors.barcodeBackgroundDark} 100%
   )`,
  promoFooterBackground: `linear-gradient(260.48deg, ${colors.promoRechargeBgStart} 0%, ${colors.promoRechargeBgEnd} 100%);`,
};

if (!import.meta.env.PROD) {
  Object.freeze(colors);
  Object.freeze(gradients);
}

export type Colors = Readonly<typeof colors>;
export type Gradients = Readonly<typeof gradients>;
export type GradientKeys = keyof Gradients;
export type ColorKeys = keyof Colors;

export default colors;
